// @vue/component
import { nextTick } from 'vue';

import {
  attemptFocus,
  isElement,
  isVisible,
} from '../../../utils/dom';
import {
  DROPDOWN_CODE_DOWN,
  DROPDOWN_CODE_ESC,
  DROPDOWN_CODE_UP,
  DROPDOWN_SELECTOR_FORM,
  DROPDOWN_SELECTOR_ITEM,
} from '../config';

export default {
  computed: {
    toggler() {
      const { dropdownToggle } = this.$refs;

      return dropdownToggle ? dropdownToggle.$el || dropdownToggle : null;
    },
  },

  watch: {
    open(newValue, oldValue) {
      if (this.navigateWithKeys && newValue && newValue !== oldValue) {
        this.focusMenu();
      }
    },
  },

  methods: {
    focusMenu() {
      // Wrap in `nextTick()` to ensure menu is fully rendered/shown
      nextTick(() => {
        // Focus on the menu container on show
        attemptFocus(this.$refs.dropdownMenu);
      });
    },

    // Keyboard nav
    focusNext(evt, up) {
      const { target } = evt;

      if (!isElement(target)) {
        return;
      }

      // Ignore key up/down on form elements
      const formEl = target.closest(DROPDOWN_SELECTOR_FORM);

      if (formEl === target) {
        return;
      }

      if (!this.open || (evt && formEl)) {
        return;
      }

      evt.preventDefault();
      evt.stopPropagation();

      nextTick(() => {
        const items = this.getItems();

        if (items.length < 1) {
          return;
        }

        let index = items.indexOf(target);

        if (up && index > 0) {
          index -= 1;
        } else if (!up && index < items.length - 1) {
          index += 1;
        }

        if (index < 0) {
          index = 0;
        }

        this.focusItem(index, items);
      });
    },

    focusItem(index, items) {
      const el = items.find((el, i) => i === index);

      attemptFocus(el);
    },

    focusToggler() {
      nextTick(() => {
        attemptFocus(this.toggler);
      });
    },

    getItems() {
      const { dropdownMenu } = this.$refs;

      if (!isElement(dropdownMenu)) {
        return [];
      }

      const items = [...dropdownMenu.querySelectorAll(DROPDOWN_SELECTOR_ITEM)];

      return items.filter(isVisible);
    },

    // If user presses ESC, close the menu
    onEsc(evt) {
      if (this.open) {
        this.toggle(false);
        evt.preventDefault();
        evt.stopPropagation();
        // Return focus to original trigger button
        this.focusToggler();
      }
    },

    onKeydown(evt) {
      if (!this.navigateWithKeys) {
        return;
      }

      const { keyCode } = evt;

      if (keyCode === DROPDOWN_CODE_ESC) {
        // Close on ESC
        this.onEsc(evt);
      } else if (keyCode === DROPDOWN_CODE_DOWN) {
        // Down Arrow
        this.focusNext(evt, false);
      } else if (keyCode === DROPDOWN_CODE_UP) {
        // Up Arrow
        this.focusNext(evt, true);
      }
    },
  },
};
